// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"73":"3e2af314","174":"26654208","537":"ac7371e5","575":"392baadb","785":"b30cc808","787":"9b76bdbb","951":"e4d306d7"}[chunkId] + ".chunk.js";
};